import { useTranslation } from "../../state/i18n.tsx";
import { Show } from "solid-js";
import InlineMessage from "../../components/inlineMessage/InlineMessage.tsx";
import { directUserToSupport } from "../../utils/supportUtil.ts";
import { TextButton } from "../../components/button/Button.tsx";
import type { FormApi } from "../../components/form/createForm.ts";

export type NavigationProps = {
  form: FormApi<never>;
  back: () => void;
  showWarning?: boolean;
};

export const OnboardingNavigation = (steps: { current: number; total: number }) => (props: NavigationProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Show when={props.showWarning}>
        <InlineMessage
          variant="warning"
          label={t(($) => $.ONBOARDING_PAGE_SUBMIT_ERROR_LABEL)}
          action={{
            label: t(($) => $.ONBOARDING_PAGE_SUBMIT_ERROR_ACTION_LABEL),
            onClick: directUserToSupport,
          }}
          class="mt-6"
        />
      </Show>
      <div class="mt-auto flex items-center justify-between pt-10">
        <p class="text-secondary">
          {steps.current} of {steps.total}
        </p>
        <div class="flex gap-2">
          <Show when={steps.current > 1}>
            <TextButton text={t(($) => $.ONBOARDING_PAGE_BACK)} onClick={props.back} variant="secondary" />
          </Show>
          <TextButton
            text={
              steps.current < steps.total ? t(($) => $.ONBOARDING_PAGE_NEXT) : t(($) => $.ONBOARDING_PAGE_GET_STARTED)
            }
            type="submit"
            form={props.form.id}
            loading={props.form.isSubmitting()}
            disabled={props.form.submitDisabled()}
          />
        </div>
      </div>
    </>
  );
};
